var _path, _path2, _rect, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIDlabel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 32,
    viewBox: "0 0 55 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5046 15.5033C13.4606 15.5033 15.0462 13.9176 15.0462 11.9616C15.0462 10.0056 13.4606 8.41992 11.5046 8.41992C9.54855 8.41992 7.96289 10.0056 7.96289 11.9616C7.96289 13.9176 9.54855 15.5033 11.5046 15.5033Z",
    fill: "#FF8400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5032 17.2754C7.95445 17.2754 5.06445 19.6554 5.06445 22.5879C5.06445 22.7862 5.22029 22.9421 5.41862 22.9421H17.5878C17.7861 22.9421 17.9419 22.7862 17.9419 22.5879C17.9419 19.6554 15.052 17.2754 11.5032 17.2754Z",
    fill: "#FF8400"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.668,
    y: 10.0049,
    width: 30.3286,
    height: 1.3429,
    rx: 0.671448,
    fill: "#FF8400"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.668,
    y: 14.8311,
    width: 30.3286,
    height: 1.3429,
    rx: 0.671448,
    fill: "#FF8400"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21.668,
    y: 19.6602,
    width: 30.3286,
    height: 1.3429,
    rx: 0.671448,
    fill: "#FF8400"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.253906,
    width: 54.5,
    height: 30.5,
    rx: 1.75,
    stroke: "#FF8400",
    strokeOpacity: 0.28,
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIDlabel);
export default __webpack_public_path__ + "static/media/IDlabel.a3e5166f34f7c255dea6dc31f8c8823b.svg";
export { ForwardRef as ReactComponent };